import { emitEvent } from "./events-v2.js";

function stagingBuild(buildId: string): boolean {
  const id = buildId.trim().toLowerCase();
  return id.includes("novapay-116") || id.includes("staging") || id.includes("rc2");
}

/** Staging-only sanitized launch diagnostics (no initData, no PII). */
export function emitStagingLaunchDiagnostics(buildId: string): Record<string, string> {
  if (!stagingBuild(buildId)) return {};
  const wa = (window as unknown as { Telegram?: { WebApp?: Record<string, unknown> } }).Telegram?.WebApp;
  const platform = String(wa?.platform ?? "browser").slice(0, 32);
  const tgVersion = String(wa?.version ?? "n/a").slice(0, 16);
  let launchSource = "direct";
  try {
    const unsafe = (wa?.initDataUnsafe ?? {}) as { start_param?: string };
    if (typeof unsafe.start_param === "string" && unsafe.start_param.trim()) {
      launchSource = "start_param";
    } else if (new URLSearchParams(window.location.search).get("build")) {
      launchSource = "build_query";
    } else if (new URLSearchParams(window.location.search).get("tgWebAppStartParam")) {
      launchSource = "tg_web_app_start_param";
    }
  } catch {
    /* ignore */
  }
  const correlationId =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID().slice(0, 12)
      : `lc${Date.now().toString(36)}`;
  const props = {
    tg_platform: platform,
    tg_version: tgVersion,
    launch_source: launchSource,
    correlation_id: correlationId,
  };
  try {
    console.info("[sv2-launch-diag]", { build: buildId, ...props });
  } catch {
    /* ignore */
  }
  emitEvent("app_open", props);
  return props;
}
